import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BehaviorSubject, delay, Observable, of } from 'rxjs';
import { environment } from 'src/environments/environment';
import { NAVIGATE_ROUTES } from '../../global/constants';
import { ToastrService } from 'ngx-toastr';

@Injectable({
    providedIn: 'root',
})
export class SignUpService {
    apiUrl: string = environment.url;
    apiEndPoint = NAVIGATE_ROUTES;
    error: string | undefined;
    responseData: any[] = [];
    name: any;
    val: any;
    userEmail!: BehaviorSubject<number>;
    constructor(private http: HttpClient, public toastService: ToastrService) {
        this.userEmail = new BehaviorSubject(this.name);
    }
    getEmail(name: any) {
        this.userEmail.next(name);
    }
    async signUp(data: any): Promise<Observable<any>> {
        this.responseData.length = 0;
        this.http.post<any>(this.apiEndPoint.SIGN_UP, data).subscribe({
            next: (_data) => {
                this.responseData.length = 0;
                this.responseData.push(_data);
            },
            error: (err: HttpErrorResponse) => {
                this.responseData.length = 0;
                this.error =
          err.error.error ||
          err.error.err ||
          err.error.msg ||
          err.error.message ||
          'Internal server error!';
                this.toastService.error(this.error);
                if (err.status) {
                    this.responseData.push('error');
                }
            },
        });
        return of(this.responseData).pipe(delay(100));
    }
}
